module.exports = __webpack_public_path__ + "img/6.67d55b47.png";